import React, { Component } from "react";
import { connect } from "react-redux";
import { Section } from "@sunwing/components";

import { CONSTANTS } from "utilities/constants";
import { withRouter } from "utilities/withRouter";
import { customQuoteError } from "models/error";
import * as actions from "modules/common/store/actions";

import commonUtilities from "utilities/common";
import validateCustomQuote from "./validateCustomQuote";

import CustomizeQuoteStepOne from "components/quote/customize/customizeSteps/stepOne/index";
import CustomizeQuoteStepTwo from "components/quote/customize/customizeSteps/stepTwo/index";
import CustomizeQuoteStepThree from "components/quote/customize/customizeSteps/stepThree/index";
import CustomizeQuoteStepFour from "components/quote/customize/customizeSteps/stepFour/index";
import CustomizeQuoteStepFive from "components/quote/customize/customizeSteps/stepFive/index";
import CustomizeQuoteStepSix from "components/quote/customize/customizeSteps/stepSix/index";
import CustomizeQuoteStepSeven from "components/quote/customize/customizeSteps/stepSeven/index";

import StepIndicator from "components/common/stepIndicator/stepIndicator";
import PreviousButton from "components/quote/customize/previousButton";
import NextButton from "components/quote/customize/nextButton";
import PageHeader from "components/common/pageHeader/pageHeader";

import QuoteBar from "./quoteBar";
import StepConfirmation from "components/quote/customize/stepConfirmation";
import ConfirmDialog from "components/common/popups/confirmDialog";
import GetQuoteError from "components/common/popups/getQuoteError/getQuoteError";
import { generateCustomQuotePdf, updateCustomQuote } from "services/customQuote/customQuote.service";
import contentHelper from "utilities/contentHelper";

import "./customizeQuote.css";

class CustomizeQuoteWizard extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            allTermsReviewed: false,
            getPDFError: false,
            currentStep: 1,
            showConfirmation: false,
            showCancelConfirmDialog: false,
            errors: JSON.parse(JSON.stringify(customQuoteError)),
            languageCode: this.props.languageCode ?? commonUtilities.getLanguage()
        };
    }

    _prev = () => {
        let currentStep = this.state.currentStep;
        if(currentStep === 1) {
            this.goBack();
        }
        else{
            window.scrollTo(0, 0);
            currentStep = currentStep <= 1 ? 1 : currentStep - 1;
            this.setState({ currentStep });
        }
    };

    _next = () => {
        window.scrollTo(0, 0);
        let { currentStep } = this.state;
        currentStep = currentStep >= 6 ? 7 : currentStep + 1;
        this.setState({ currentStep });
    };

    goBack = () => {
        let { currentRoute } = this.props;
        if(currentRoute && currentRoute?.toLowerCase().endsWith("/customize")) {
            let newRoute = currentRoute?.toLowerCase().replace("/customize", "");
            this.props.navigate(newRoute);            
        }
    };

    onEditCustomQuote = () => {
        let { currentStep } = this.state;
        currentStep = 1;
        this.setState({ currentStep });
    };

    onCancel = () => {
        this.toggleCancelConfirmDialog(true);
    };

    onGeneratePDF = () => {
        this.props.showProcessingSpinner(true);
        const payload = contentHelper.finalizeQuoteResponse(structuredClone(this.props.customQuote), true);
        this.props.dispatch(generateCustomQuotePdf(payload?.data)).then((response) => {
            this.props.showProcessingSpinner(false);
            if(response?.type === actions.GET_CUSTOM_QUOTE_PDF_SUCCESS) {
                // good, go to next page
                let { currentRoute } = this.props;
                if(currentRoute && currentRoute?.toLowerCase().endsWith("/customize")) {
                    let newRoute = currentRoute?.toLowerCase().replace("/customize", "/customize/pdf");
                    this.props.navigate(newRoute);     
                    //window.open(newRoute, "_blank");       
                }
            }
            else {
                this.togglePDFErrorPopup(true);
            }
            
        }).catch(error => {
            this.props.showProcessingSpinner(false);
            this.togglePDFErrorPopup(true);
            //this.setState({ getQuoteLoading: false, getPDFError: true });
            console.log(error);
        });
    };

    isStepDataValid = (isNextClick, currentStep) => {
        switch(currentStep) {
        case 1:
            if(isNextClick && this.isStep1DataValid()) {
                if(this.needStep1DataConfirmation()){ 
                    this.updateSelectedItinerariesWarning(); 
                    this.toggleConfirmationPopup(true); 
                }
                else {this._next(); }
            }
            break;
        case 2:
            if(isNextClick && this.isStep2DataValid()) {
                if(this.needStep2DataConfirmation()){ this.toggleConfirmationPopup(true); }
                else {this._next(); }
            }
            break;
        case 3:
            if(isNextClick && this.isStep3DataValid()) {
                if(this.needStep3DataConfirmation()){ this.toggleConfirmationPopup(true); }
                else {this._next(); }
            }
            break;
        case 4:
            if(isNextClick && this.isStep4DataValid()) {
                if(this.needStep4DataConfirmation()){ this.toggleConfirmationPopup(true); }
                else {this._next(); }
            }
            break;
        case 5:
            if(isNextClick && this.needStep5DataConfirmation()){ this.toggleConfirmationPopup(true); }
            else {this._next(); }
            break;
        case 6:
            if(isNextClick && this.needStep6DataConfirmation()) { this.toggleConfirmationPopup(true); }
            else {
                this._next();
            }
            break;
        }
    };

    isStep1DataValid() {
        let { errors } = this.state;
        validateCustomQuote.validateItinerarySelection(this.props.customQuote, errors, this.props.localize);

        let { itinerarySelection } = errors;
        this.setState({ errors });

        return !(itinerarySelection && itinerarySelection.trim().length > 0);
    }

    needStep1DataConfirmation() {
        let hasNoChange = false;
        const data = this.props.customQuote?.data;
        if (!data) return false;
        
        const TODAY = commonUtilities.getTodayDate();

        for (const option of data.quoteOptions ?? []) {
            for (const product of option.products ?? []) {
                for (const itinerary of product.itineraries ?? []) {
                    const durationToToday = commonUtilities.calculateDuration(TODAY, itinerary.originalValidDate);

                    if (!itinerary.included || durationToToday <= 0) continue;

                    if(!contentHelper.itineraryExpiryDateChanged(itinerary)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    updateSelectedItinerariesWarning = () =>{
        const TODAY = commonUtilities.getTodayDate();
        let { customQuote } = this.props;
        this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map((itinerary) => {
                    
                        const durationToToday = commonUtilities.calculateDuration(TODAY, itinerary.originalValidDate);

                        if (!itinerary.included || durationToToday <= 0 || contentHelper.itineraryExpiryDateChanged(itinerary)) return { ...itinerary };
                        return { ...itinerary, showValidDateWarningIcon: true };
                    })
                }))
            }))
        }));
    };

    isStep2DataValid() {
        let { errors } = this.state;
        validateCustomQuote.validateIndividualItineraryMarkupSelection(this.props.customQuote, errors, this.props.localize);

        let { individualItineraryMarkupSelection } = errors;
        this.setState({ errors });

        return !(individualItineraryMarkupSelection && individualItineraryMarkupSelection.trim().length > 0);
    }

    needStep2DataConfirmation() {
        const { customQuote } = this.props;
        const data = customQuote?.data;

        if (!data) return false;

        const isInvalid = (markup, adultOnly) => {
            const { adult, child } = contentHelper.validateMarkup(markup, adultOnly);
            return !(adult && child);
        };

        // Case 1: Markup coverage ALL
        if (data.markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL) {
            const isAdultOnlyQuote = this.isAdultOnlyQuote(data?.quoteOptions);
            return data.markup ? isInvalid(data.markup, isAdultOnlyQuote) : false;
        }

        // Case 2: Per-itinerary markup
        return data.quoteOptions?.some(quoteOption =>
            quoteOption.products?.some(product =>
                product.itineraries?.some(itinerary =>
                    itinerary.included && isInvalid(itinerary.markup, itinerary.adultOnly)
                )
            )
        ) ?? false;
    }

    isAdultOnlyQuote = (quoteOptions) => {
        const adultOnlyQuote = quoteOptions?.every(option =>
            option?.products?.every(product =>
                product?.itineraries?.every(itinerary =>
                    !itinerary?.included || (itinerary.adultOnly ?? false)
                )
            )
        ) ?? false;
        return  adultOnlyQuote;
    };


    isStep3DataValid() {
        let { errors } = this.state;
        validateCustomQuote.validateSelectedConcessions(this.props.customQuote, errors, this.props.localize);
        let { selectedConcessions } = errors;
        this.setState({ errors });

        return !(selectedConcessions && selectedConcessions.trim().length > 0);
    }
    
    needStep3DataConfirmation() {
        const quoteOptions = this.props.customQuote?.data?.quoteOptions ?? [];

        let hasSelectableConcession = false;

        for (const quoteOption of quoteOptions) {
            for (const product of quoteOption.products ?? []) {
                for (const itinerary of product.itineraries ?? []) {
                    if (
                        itinerary?.included &&
                        !itinerary.hideRoomConcession
                    ) {
                        const concessions =
                            itinerary?.itineraryDetail?.roomType?.customConcessions ?? [];

                        if (concessions.length > 0) {
                            hasSelectableConcession = true;

                            if (concessions.some(c => c.included)) {
                                return false; // already selected → no confirmation needed
                            }
                        }
                    }
                }
            }
        }

        return hasSelectableConcession;
    }

    isStep4DataValid() {
        let { errors } = this.state;
        validateCustomQuote.validateSelectedPromotions(this.props.customQuote, errors, this.props.localize);
        let { selectedPromotions } = errors;
        this.setState({ errors });

        return !(selectedPromotions && selectedPromotions.trim().length > 0);
    }

    needStep4DataConfirmation() {
        const promotions = this.props.customQuote?.data?.promotions ?? [];
        return !promotions.some(promotion => promotion.included);
    }

    needStep5DataConfirmation() {
        const termsAndConditions = this.props.customQuote?.data?.termsAndConditions ?? [];
        return termsAndConditions.some(term => !term.isChanged);
    }

    needStep6DataConfirmation() {
        let updated = true;
        let { customQuote } = this.props;
        if(customQuote?.data?.originalAdditionalRequirements === customQuote?.data?.additionalRequirements){
            updated = false;   
        }
        return !updated;
    }

    onAlertClose = () => {
        let { errors } = this.state;
        errors = JSON.parse(JSON.stringify(customQuoteError));
        this.setState({ errors });
    };

    handleCancel = () =>{
        this.toggleConfirmationPopup(false);
    }; 
    
    handleContinue = () => {
        this.toggleConfirmationPopup(false);
        this._next();
    };

    toggleConfirmationPopup(show) {
        let { showConfirmation } = this.state;
        showConfirmation = show;
        this.setState({ showConfirmation });
    }

    toggleCancelConfirmDialog(show) {
        let { showCancelConfirmDialog } = this.state;
        showCancelConfirmDialog = show;
        this.setState({ showCancelConfirmDialog });
    }

    togglePDFErrorPopup(show) {
        let { getPDFError } = this.state;
        getPDFError = show;
        this.setState({ getPDFError });
    }

    onGetPDFErrorCancel = (value) => {
        this.togglePDFErrorPopup(false);
    };

    onTermTabChange = (tabIndex) => {
        const termsAndConditions = this.props.customQuote?.data?.termsAndConditions || [];
        if(termsAndConditions.length > 0) {
            let { allTermsReviewed } = this.state;
            allTermsReviewed = termsAndConditions.filter((s, index) => index !== tabIndex && s.isReviewed === false).length === 0;
            this.setState( { allTermsReviewed });
        }
    };

    render() {
        let { customQuote } = this.props;
        let {
            allTermsReviewed,
            getPDFError,
            currentStep,
            errors,
            showConfirmation,
            showCancelConfirmDialog 
        } = this.state;

        const termsAndConditions = customQuote?.data?.termsAndConditions || [];
        if(termsAndConditions.length <= 1){
            allTermsReviewed = true;
        }

        return (
            <>
                <Section>
                    <PageHeader isCustomQuote={true} isPreview={currentStep === 7}/>
                </Section>
                <div className="row">
                    <QuoteBar 
                        data={{ currentStep, customQuote }}  
                        events={{
                            onEditCustomQuote: this.onEditCustomQuote,
                            onCancel: this.onCancel,
                            onGeneratePDF: this.onGeneratePDF
                        }}
                    />
                    <Section>
                        {
                            showConfirmation ? 
                                <StepConfirmation  
                                    data={{ currentStep }}
                                    events={{
                                        handleCancel: this.handleCancel,
                                        handleContinue: this.handleContinue
                                    }}
                                />
                                : null
                        }
                        {
                            showCancelConfirmDialog ? 
                                <ConfirmDialog
                                    heading={this.props.localize("qma-custom-quote-cancel-button-confirmation")}
                                    buttons={[
                                        {
                                            label: this.props.localize("qma-button-label-no-cancel"),
                                            onClick: () => this.toggleCancelConfirmDialog(false)
                                        },
                                        {
                                            label: this.props.localize("qma-button-label-yes-cancel"),
                                            onClick: () => { this.toggleCancelConfirmDialog(false); this.goBack(); }
                                        }
                                    ]}
                                /> : null
                        }
                        <div className="custom-quote-editor">
                            <div className="row wizard-container">
                                <StepIndicator data={{ currentStep }} />
                                {currentStep !== 7 ?
                                    <div className={"steps-editor step-" + currentStep}>
                                        <CustomizeQuoteStepOne
                                            data={{ currentStep }}
                                            error={errors?.itinerarySelection}
                                            events={{
                                                onAlertClose: this.onAlertClose,
                                                onValidateStep1Data: () => this.isStep1DataValid()
                                            }}
                                        />
                                        <CustomizeQuoteStepTwo
                                            data={{ currentStep }}
                                            error={errors?.individualItineraryMarkupSelection}
                                            events={{
                                                onAlertClose: this.onAlertClose
                                            }}
                                            isAdultOnlyQuote={this.isAdultOnlyQuote}
                                        />
                                        <CustomizeQuoteStepThree
                                            data={{ currentStep }}
                                            errors={errors}
                                            error={errors?.selectedConcessions}
                                            events={{
                                                onAlertClose: this.onAlertClose
                                            }}
                                        />
                                        <CustomizeQuoteStepFour
                                            data={{ currentStep }}
                                            errors={errors}
                                            error={errors?.selectedPromotions}
                                            events={{
                                                onAlertClose: this.onAlertClose
                                            }}
                                        />
                                        <CustomizeQuoteStepFive
                                            data={{ currentStep }}
                                            errors={errors}
                                            events={{
                                                onTermTabChange: this.onTermTabChange
                                            }}
                                        />
                                        <CustomizeQuoteStepSix
                                            data={{ currentStep }}
                                            errors={errors}
                                        />
                                    </div>
                                    :null
                                }
                            </div>
                            <CustomizeQuoteStepSeven
                                data={{ currentStep }}
                                errors={errors}
                            />
                            {currentStep === 7 ? null :
                                <div className="wizard-footer customize-quote row">
                                    <PreviousButton
                                        events={{ previous: this._prev }}
                                        data={{ currentStep }}
                                    />
                                    <NextButton
                                        events={{
                                            isStepDataValid: this.isStepDataValid
                                        }}
                                        data={{ currentStep, allTermsReviewed }}
                                    />
                                </div>
                            }
                        </div>
                    </Section>
                    <QuoteBar 
                        data={{ currentStep, forFooter: true }} 
                        events={{
                            onEditCustomQuote: this.onEditCustomQuote,
                            onCancel: this.onCancel,
                            onGeneratePDF: this.onGeneratePDF
                        }}
                    />
                    <GetQuoteError
                        isShow={getPDFError}
                        onCancel={(value) => this.onGetPDFErrorCancel(value)}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withRouter(CustomizeQuoteWizard));